// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as OptionTypeUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as ModalContext$PorterinFeature from "../../../../contexts/modal-context/ModalContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../../shared/core/constants/GAEventsConstants.mjs";
import * as CitySelectorModuleScss from "../styles/CitySelector.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";

var styles = CitySelectorModuleScss;

function CitySelectorCmp(Props) {
  var city_selector_data = Props.city_selector_data;
  var location_icon = Props.location_icon;
  var drop_down_icon = Props.drop_down_icon;
  var close_icon = Props.close_icon;
  var city_title_desc = Props.city_title_desc;
  var city_label_prefix = Props.city_label_prefix;
  var modalContext = ModalContext$PorterinFeature.useModalContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: styles["city-selector-wrapper"]
            }, React.createElement("div", {
                  className: styles["city-selector-button"],
                  onClick: (function (param) {
                      if (city_selector_data.length > 1) {
                        PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaCitySelectorAction, citySelectedContext.city_selected);
                        return Curry._1(modalContext.toggleModal, {
                                    TAG: /* CitySelector */7,
                                    _0: true,
                                    _1: city_selector_data,
                                    _2: close_icon,
                                    _3: city_title_desc
                                  });
                      }
                      
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: location_icon.path,
                      height: 20.0,
                      width: 20.0,
                      quality: 100.0,
                      alt: location_icon.alt_text
                    }), React.createElement("div", {
                      className: styles["city-selector-text-wrapper"]
                    }, React.createElement("p", {
                          className: styles["city-selector-text"]
                        }, city_label_prefix), React.createElement("p", {
                          className: styles["city-selected-text"]
                        }, OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(citySelectedContext.selected_city_label))), city_selector_data.length > 1 ? React.createElement(NextImage$PorterinFeature.make, {
                        src: drop_down_icon.path,
                        height: 20.0,
                        width: 20.0,
                        quality: 100.0,
                        alt: drop_down_icon.alt_text
                      }) : null));
}

var make = CitySelectorCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
